module.exports = __webpack_public_path__ + "img/add-user-dialog.59779ff4.png";